"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Enum = require("@novivia/utilities/types/Enum");

var _Enum2 = _interopRequireDefault(_Enum);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Type of an AuctionEx service.
// AE_SERVICE_TYPE
exports.default = new _Enum2.default(["AUCTION_HANDLER"]); /**
                                                            * Copyright 2013-present, Novivia, Inc.
                                                            * All rights reserved.
                                                            */

module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/configurations/lib/common/AE_SERVICE_TYPE.js
// module id = 71
// module chunks = 9 10 11 12 13 14 15 18 19 20 21 22 23 24 25 26 27 28 29 30 33 34 35 38 39 40 41 42 43 45 46 47 48 49 50 51 54